import type { ELanguage } from '../languageHelper';

import { type ITextBase, oftenUsedTranslations } from './oftenUsed';

export interface IChatAgentTexts extends ITextBase {
    conversationLoadingText: string;
    inputPlaceholder: string;
    chatEmptyText: string;
    dialogTitle: string;
    chatTitle: string;
    chatSubtitle: string;
    howCanIHelp: string;
    howCanIHelpWithName: string;
    myChatTitle: string;
    chatHistory: string;
    chatSearch: string;
    newChat: string;
    lastChats: string;
    searchPlaceholder: string;
    aiChatTooltip: string;
    deleteChat: string;
    sendMessage: string;
}
type ILangData = {
    [lang in ELanguage]: IChatAgentTexts;
};
export const chatAgentTexts: ILangData = {
    th: {
        conversationLoadingText: 'กำลังเริ่มเอเจนต์ AI ของคุณ โปรดรอสักครู่!',
        inputPlaceholder: 'คุณสามารถทำอะไรเพื่อฉันได้บ้าง?',
        chatEmptyText: 'ยังไม่มีข้อความ',
        dialogTitle: 'การสนับสนุนการแชท AI',
        chatTitle: '[TH] Chat Title',
        chatSubtitle: '[TH] Chat Subtitle',
        howCanIHelp: '[TH] How can I help?',
        howCanIHelpWithName: '[TH] What can we do today, {firstName}?',
        myChatTitle: '[TH] My Chat',
        chatHistory: '[TH] Chat History',
        chatSearch: '[TH] Chat Search',
        newChat: '[TH] New Chat',
        lastChats: '[TH] Last Chats:',
        searchPlaceholder: '[TH] Search chat title...',
        aiChatTooltip: '[TH] AI Chat',
        deleteChat: '[TH] Delete Chat',
        sendMessage: '[TH] Send Message',
        oftenUsed: oftenUsedTranslations.th,
    },
    en: {
        conversationLoadingText: 'Your AI agent is being started, please be patient for a moment!',
        inputPlaceholder: 'What can I do for you?',
        chatEmptyText: 'No messages yet',
        dialogTitle: 'AI Chat Support',
        chatTitle: 'Skill-App AI',
        chatSubtitle: 'Your intelligent assistant for professional development',
        howCanIHelp: 'How can I help you?',
        howCanIHelpWithName: 'What can we do today, {firstName}?',
        myChatTitle: 'My Chat',
        chatHistory: 'Chat History',
        chatSearch: 'Search Chat',
        newChat: 'New Chat',
        lastChats: 'Recent Chats:',
        searchPlaceholder: 'Search chat title...',
        aiChatTooltip: 'AI Chat',
        deleteChat: 'Delete Chat',
        sendMessage: 'Send Message',
        oftenUsed: oftenUsedTranslations.en,
    },
    de: {
        oftenUsed: oftenUsedTranslations.de,
        dialogTitle: 'KI-Chat Unterstützung',
        chatEmptyText: 'Noch keine Nachrichten',
        inputPlaceholder: 'Was kann ich heute für dich tun?',
        conversationLoadingText: 'Dein KI-Agent wird für dich gestartet, Ich bitte um einen Augenblick Geduld!',
        chatTitle: 'Skill-App KI',
        chatSubtitle: 'Dein intelligenter Assistent für berufliche Entwicklung',
        howCanIHelp: 'Wie kann ich dir helfen?',
        howCanIHelpWithName: 'Was wollen wir heute machen, {firstName}?',
        myChatTitle: 'Mein Chat',
        chatHistory: 'Chat Verlauf',
        chatSearch: 'Chat Suchen',
        newChat: 'Neuer Chat',
        lastChats: 'Letzte Chats:',
        searchPlaceholder: 'Nach Chat-Titel suchen...',
        aiChatTooltip: 'KI Chat',
        deleteChat: 'Chat löschen',
        sendMessage: 'Nachricht senden',
    },
};
